import React from 'react';

const DirecaoContext = React.createContext();

export default DirecaoContext;